export var ReaderTheme;
(function (ReaderTheme) {
    ReaderTheme["LIGHT"] = "light";
    ReaderTheme["DARK"] = "dark";
    ReaderTheme["SEPIA"] = "sepia";
})(ReaderTheme || (ReaderTheme = {}));
//# sourceMappingURL=ReaderTheme.js.map